/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type TicketView = typeof TicketView[keyof typeof TicketView];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketView = {
  All: 'All',
  Open: 'Open',
  Closed: 'Closed',
  FromGridOperator: 'FromGridOperator',
  Telemetry: 'Telemetry',
  InProgress: 'InProgress',
  Unread: 'Unread',
  Reaction: 'Reaction',
  NonConformity: 'NonConformity',
  Handled: 'Handled',
  OpenOrHandled: 'OpenOrHandled',
  ActionNeeded: 'ActionNeeded',
  Stale: 'Stale',
} as const;
